<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <filter-layout
    title="룸타입"
    sub-title="중복 선택이 가능합니다."
    :sub-title-style="{
      color: '#cccccc',
      'font-size': '1.2rem'
    }"
    padding-y="3rem"
    padding-x="3.2rem"
    width="29rem"
    class="room-filter"
    v-show="isShow"
  >
    <ul class="room-type-list">
      <li @click="toggleRoomType('M')" :class="{on: isClickedRoomType('M')}">
        <span>미니룸</span>
        <span class="room-type-desc">(공용화장실 / 공용샤워실)</span>
      </li>
      <li @click="toggleRoomType('S')" :class="{on: isClickedRoomType('S')}">
        <span>샤워룸</span>
        <span class="room-type-desc">(공용화장실 / 개인샤워실)</span>
      </li>
      <li @click="toggleRoomType('O')" :class="{on: isClickedRoomType('O')}">
        <span>원룸</span>
        <span class="room-type-desc">(개인화장실 / 개인샤워실)</span>
      </li>
    </ul>
  </filter-layout>
</template>

<script>
  import FilterLayout from '../Layout/FilterLayout'
  import {mapState} from 'vuex'
  export default {
    name: 'RoomTypeFilter',
    components: {FilterLayout},
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapState({
        selectedRoomType: state => state.FILTERS.ROOM_TYPE
      })
    },
    methods: {
      toggleRoomType (type) {
        this.$store.dispatch('toggleRoomType', type)
        console.log(this.selectedRoomType)
      },
      isClickedRoomType (type) {
        return this.selectedRoomType.indexOf(type) > -1
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .room-filter {
    li {
      line-height: 4.65rem;
      font-weight: bold;
      border: 1px solid @very-light-pink-two;
      color: @brown-grey;
      margin: 1rem 0;
      box-sizing: border-box;

      &:first-child {
        margin: 0 0 1rem 0;
      }

      &:last-child {
        margin: 1rem 0 0 0;
      }

      &.on {
        background-color: @windows-blue;
        color: @white;
        border: 0;
      }
    
      .room-type-desc {
        margin-left: .85rem;
        font-size: 1.2rem;
      }
    }
  }
</style>
